import { FC } from "react";
import { useRouter } from "next/navigation";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";

import { useAppDispatch } from "@/redux/store";
import { setRoomUUID, setGenerations } from "@/redux/actions";

interface ViewCommentsProps {
  roomUUID?: string;
  totalComments?: number;
}

const ViewComments: FC<ViewCommentsProps> = ({
  roomUUID,
  totalComments = 0,
}) => {
  const dispatch = useAppDispatch();
  const router = useRouter();

  const handleCommentsClick = () => {
    if (!roomUUID) return;
    dispatch(setRoomUUID(null));
    dispatch(setGenerations([]));
    router.push(`/idea/${roomUUID}?displayComments=true`);
  };

  return (
    <IconButton
      sx={{ color: "primary.main" }}
      onClick={handleCommentsClick}
      disabled={!roomUUID}
    >
      <Badge badgeContent={totalComments} color="secondary">
        <ChatBubbleOutlineIcon />
      </Badge>
    </IconButton>
  );
};

export default ViewComments;
